<template>
  <div>
    <Panel
      module="Planner"
      title="Configuração"
      :showFilter="false"
      :showSearch="false"
      :showButtons="false"
    >
      <div slot="content-main">
        <br>
        <b-tabs>
          <b-tab title="Tag">
            <PlannerTagConfig />
          </b-tab>
        </b-tabs>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";

import PlannerTagConfig from "../components/shared/PlannerTagConfig.vue";

import { mapMutations } from "vuex";

export default {
  name: "PlannerConfig",
  components: { Panel, PlannerTagConfig },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>


